import React, { use, useEffect, useState } from "react";
import { Building, Gauge } from "lucide-react";
import { useUser } from "@/app/context/UserContext";

 

export default function QuotaOrganization() {
    const { user, userProject, setUserProject } = useUser();
    const [usedPorcentaje, setUsedPorcentaje] = useState<number>(0);
    const [usedProjects, setUsedProjects] = useState<number>(0);

    
    const usedQuota = () => {
        const quotaConfig = userProject?.project?.quota_config;
        const domainQuota = quotaConfig?.domain_quota ?? 0;
        const totalDomainQuota = userProject.project.quota_project_domain?? 0;
        const percentage = domainQuota > 0
            ? (totalDomainQuota / domainQuota) * 100
            : 0;

        setUsedPorcentaje(percentage);
        setUsedProjects(totalDomainQuota);
    };

    useEffect(() => {
    if (userProject?.project?.quota !== undefined) {
        usedQuota();
    }
    }, [ 
    userProject?.project?.quota,
    userProject?.project?.quota_config
    ]);

    return (
        <div className="flex items-center gap-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100">
            <Building className="w-6 h-6 text-blue-600" strokeWidth={1.5} />
        </div>
        <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-800">Organización: {user.domain}</h2>
            <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                <Gauge className="w-4 h-4 text-blue-500" />
                <span>Cuota asignada:</span><span className="font-semibold text-gray-800">$ {userProject.project.quota_config?.domain_quota}</span>
            </div>
            <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                <Gauge className="w-4 h-4 text-blue-500" />
                <span>Cuota asignada a proyectos:</span><span className="font-semibold text-gray-800">$ {usedProjects.toFixed(2)}</span>
            </div>
            {/* Barra de progreso */}
            <div className="mt-2 h-2 w-full rounded-full bg-gray-200">
                <div
                    className={`h-2 rounded-full transition-all duration-300 ${usedPorcentaje > 100 ? "bg-red-500" : "bg-blue-500"}`}
                    style={{ width: `${usedPorcentaje>100?100:usedPorcentaje}%` }}
                />
            </div>
            
        </div>
    </div>
        
    );
}
